
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/DailyMaintenance/index.vue"
}
